// extracted by mini-css-extract-plugin
export default {"wrapper":"see-more_wrapper__jK09j","text":"see-more_text__eqZzT","icon":"see-more_icon__duM2F"};